export default __webpack_public_path__ + "static/media/azuki.e74a3920.png";